module.exports = __webpack_public_path__ + "static/media/world-export.538cb7ce.svg";